export enum ContactStatus {
  Current = 1,
  Expired = 2,
}
